import urls from "@/config/urls.js";

export default {
  computed: { urls: () => urls }
};
